import { createContext, useContext } from 'react'
import type {
	LocationResult,
	FlexOfficeResult,
} from '@alexanderathoodly/data-models'

type TLocationPageContext = {
	location: LocationResult | undefined
}

export const LocationPageContext = createContext<TLocationPageContext>({
	location: undefined,
})

export const useLocationPage: () => TLocationPageContext = () =>
	useContext(LocationPageContext)

type TCurrentOfficeContext = {
	currentOffice: FlexOfficeResult | undefined
}

export const CurrentOfficeContext = createContext<TCurrentOfficeContext>({
	currentOffice: undefined,
})

export const useCurrentOffice: () => TCurrentOfficeContext = () =>
	useContext(CurrentOfficeContext)
